/* @ngInject */
const myWagonInputId = (
  wagonUtils
) => {
  return {
    restrict: 'E',
    scope: {
      myId: '=',
      myRequired: '=?',
    },
    template: require('./myWagonInputId.html'),

    /* @ngInject */
    controller: ($scope) => {
      const id = wagonUtils.stringToId($scope.myId)
      if (wagonUtils.isIdValid($scope.myId)) {
        $scope.id1 = id.toString().slice(0, 2)
        $scope.id2 = id.toString().slice(2, 4)
        $scope.id3 = id.toString().slice(4, 7)
        $scope.id4 = id.toString().slice(7, 11)
      } else {
        $scope.id1 = null
        $scope.id2 = null
        $scope.id3 = null
        $scope.id4 = null
      }

      $scope.$watch('myId', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          if (!wagonUtils.isIdValid($scope.myId)) {
            $scope.idForm.$setPristine()
            $scope.idForm.$setUntouched()
            $scope.id1 = null
            $scope.id2 = null
            $scope.id3 = null
            $scope.id4 = null
          } else {
            $scope.id1 = $scope.myId.toString().replace(/ -/g, '').slice(0, 2)
            $scope.id2 = $scope.myId.toString().replace(/ -/g, '').slice(2, 4)
            $scope.id3 = $scope.myId.toString().replace(/ -/g, '').slice(4, 7)
            $scope.id4 = $scope.myId.toString().replace(/ -/g, '').slice(7, 11)
          }
        }
      })

      $scope.$watchCollection('[id1, id2, id3, id4]', () => {
        if ($scope.id1 === null || $scope.id2 === null || $scope.id3 === null || $scope.id4 === null) {
          $scope.code = null
          return
        }

        let id = '' + $scope.id1 + $scope.id2 + $scope.id3 + $scope.id4

        if (id.length === 11) {
          $scope.code = wagonUtils.autocontrole(id)
          id += $scope.code

          $scope.myId = id
        } else {
          $scope.code = null
        }
      })
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myWagonInputId



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/inputs/myWagonInputId.js